import { render, staticRenderFns } from "./companyEdit.vue?vue&type=template&id=1ba77f53"
import script from "./companyEdit.vue?vue&type=script&lang=js"
export * from "./companyEdit.vue?vue&type=script&lang=js"
import style0 from "./companyEdit.vue?vue&type=style&index=0&id=1ba77f53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports